<template>
	<div class="path">
		<span class="path__segment" v-for="(s, i) in path" :key="i">
			{{ s.name }}
		</span>
		<span v-if="showTitle" class="path__segment greyed-out">
			{{ article.title }}
		</span>
	</div>
</template>

<script>
export default {
	name: "SearchResultPath",
	props: ["article", "showTitle"],
	computed: {
		path: function () {
			if (this.article) {
				return this.$store.getters.articlePath(this.article.id);
			} else {
				return [];
			}
		},
	},
};
</script>

<style scoped>

	.path {
		display: flex;
		align-items: center;
	}

	.path__segment {
		display: flex;
		align-items: center;
		color: var(--clr-accent-primary);
		white-space: nowrap;
	}

	.path__segment:hover {
		color: var(--clr-accent-primary-shade-7);
		text-decoration: underline;
	}

	.path__segment:not(:last-child)::after {
		content: "/";
		display: inline-block;
		margin-left: 0.4rem;
		margin-right: 0.4rem;
	}

</style>